import "../styles/ProgressBar.css";
import "../styles/Home.css";
import { useEffect, useState, useContext } from "react";
import { FeatureFlagContext } from "../context/FeatureFlagContextProvider";

const ProgressBar = ({ goal, progress, payout, promotionType }) => {
  const featureFlags = useContext(FeatureFlagContext);
  const [promotion, setPromotion] = useState("event");
  const [promotionPlural, setPromotionPlural] = useState("events");
  const [promotionVerb, setPromotionVerb] = useState("Complete");
  const [promotionPastTense, setPromotionPastTense] = useState("completed");
  const [eventsRemainingToGoal, setEventsRemainingToGoal] = useState(null);
  const [figmaHeaderFlag, setFigmaHeaderFlag] = useState(false);
  const sales = "NEWBUSINESS";
  const quotes = "QUOTES";

  const quoteDictionary = {
    promo: "Quote",
    plural: "Quotes",
    verb: "Complete",
    pastTense: "completed",
  };

  const salesDictionary = {
    promo: "Policy",
    plural: "Policies",
    verb: "Sell",
    pastTense: "sold",
  };

  useEffect(() => {
    setFigmaHeaderFlag(featureFlags?.UpdatedHeaderOnHomePageFlag);
  }, [featureFlags]);

  useEffect(() => {
    setEventsRemainingToGoal(goal - progress);

    switch (promotionType.toUpperCase()) {
      case quotes:
        setPromotion(quoteDictionary.promo);
        setPromotionVerb(quoteDictionary.verb);
        setPromotionPlural(quoteDictionary.plural);
        setPromotionPastTense(quoteDictionary.pastTense);
        break;
      case sales:
        setPromotion(salesDictionary.promo);
        setPromotionVerb(salesDictionary.verb);
        setPromotionPlural(salesDictionary.plural);
        setPromotionPastTense(salesDictionary.pastTense);
        break;
      default:
        setPromotion("events");
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [goal, progress, promotionType, promotion]);

  const progressPercentage = (progress / goal) * 100;

  return (
    <>
      {!figmaHeaderFlag ? (
        <div>
          <h5>
            You have {promotionPastTense} {progress} out of {goal}{" "}
            {promotionPlural}.
          </h5>
          <div className="progress-bar">
            <h4 style={{ textAlign: "center" }}>
              Next Payout:{" "}
              <span className="money-green">${payout.toLocaleString()}</span>
            </h4>
            <table className="progress-width" id="progress-bar">
              <thead>
                <tr></tr>
              </thead>
            </table>
            <div className="progress-text" data-testid="goal">
              <p>
                {goal} {goal === 1 ? promotion : promotionPlural}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="spif-active-area">
          <div className="progress-bar-figma">
            <div className="payout-display">${payout.toLocaleString()}</div>
            <div className="simple-progress-container">
              <div className="simple-progress-bar">
                <div
                  className="simple-progress-fill"
                  style={{ width: `${progressPercentage}%` }}
                ></div>
              </div>
            </div>
            <div className="progress-text" data-testid="goal">
              <p>
                <strong>
                  {goal} {goal === 1 ? promotion : promotionPlural}
                </strong>
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default ProgressBar;
